/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { InstanceData } from "../../../../models/instance-data";
import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: 'app-email-address-editor',
  templateUrl: './email-address-editor.component.html'
})
export class EmailAddressEditorComponent {
  
  @Input()
  mData: InstanceData;
  
  @Output()
  removeClicked = new EventEmitter<void>();
  
}
